import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { BibliographicResourceService } from '®shared/bibliographic-resource';
import { CourseReserveDatesModule } from '®shared/course-reserve-dates/course-reserve-dates.module';
import { UriModule } from '®shared/url-utils';

import { DigitalCopyComponent } from './digital-copy.component';
import { LibraryAvailabilityComponent } from './library-availability.component';
import { LibraryAvailabilityEffects } from './library-availability.effects';
import { libraryAvailabilityReducer } from './library-availability.reducer';
import {
  STATE_LIBRARY_AVAILABILITY,
  getInitialLibraryAvailabilityState,
} from './library-availability.state';

@NgModule({
  imports: [
    CommonModule,
    EffectsModule.forFeature([LibraryAvailabilityEffects]),
    StoreModule.forFeature(
      STATE_LIBRARY_AVAILABILITY,
      libraryAvailabilityReducer,
      {
        initialState: getInitialLibraryAvailabilityState,
      },
    ),
    UriModule,
    CourseReserveDatesModule,
  ],
  declarations: [DigitalCopyComponent, LibraryAvailabilityComponent],
  exports: [LibraryAvailabilityComponent, DigitalCopyComponent],
  providers: [BibliographicResourceService],
})
export class LibraryAvailabilityModule {}
